export default __webpack_public_path__ + "static/media/go-to.a2163255.svg";